"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Button, type ButtonVariant } from "@/components/ui/button";
import { trackCTAButtonClicked } from "@/lib/analytics/segment";
import { type CtaButtonEntry, resolveCtaHref } from "./ctaHref";

// Re-exported so the existing import sites keep pointing here for types.
export type { CtaButtonEntry, CtaExperiences } from "./ctaHref";
const STYLE_TO_VARIANT: Record<string, ButtonVariant> = {
  Primary: "default",
  Secondary: "outline",
  Tertiary: "ghost"
};
interface Props {
  entry: CtaButtonEntry;
  className?: string;
  onCtaClick?: () => void;
  popupId?: string; // Used in promo modal
}
export default function CTAButton(t0) {
  const $ = _c(20);
  const {
    entry,
    className,
    onCtaClick,
    popupId
  } = t0;
  const {
    buttonText,
    buttonStyle,
    openInNewTab,
    internalId
  } = entry.fields;
  const variant = STYLE_TO_VARIANT[buttonStyle] ?? "default";
  const isNewTab = openInNewTab === "New tab";
  let t1;
  if ($[0] !== entry) {
    t1 = resolveCtaHref(entry);
    $[0] = entry;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const href = t1;
  if (!href) {
    return null;
  }
  let t2;
  if ($[2] !== buttonStyle || $[3] !== buttonText || $[4] !== href || $[5] !== internalId || $[6] !== onCtaClick || $[7] !== popupId) {
    t2 = () => {
      trackCTAButtonClicked({
        name: buttonText,
        destinationUrl: href,
        variant: buttonStyle,
        internalId,
        popupId
      });
      onCtaClick?.();
    };
    $[2] = buttonStyle;
    $[3] = buttonText;
    $[4] = href;
    $[5] = internalId;
    $[6] = onCtaClick;
    $[7] = popupId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== isNewTab) {
    t3 = isNewTab && {
      target: "_blank",
      rel: "noopener noreferrer"
    };
    $[9] = isNewTab;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== buttonText || $[12] !== href || $[13] !== t2 || $[14] !== t3) {
    t4 = <Link href={href} onClick={t2} {...t3}>{buttonText}</Link>;
    $[11] = buttonText;
    $[12] = href;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== className || $[17] !== t4 || $[18] !== variant) {
    t5 = <Button asChild={true} variant={variant} className={className}>{t4}</Button>;
    $[16] = className;
    $[17] = t4;
    $[18] = variant;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}